<template>
    <div class="media-library__client-select">
        <div class="media-library__client-select-title">
            <h3>Which client would you like to see the assets for?</h3>
        </div>
        <div class="media-library__client-select-grid">
            <a
                v-for="client in clients"
                :key="client._id"
                class="media-library__client-select-grid-card"
                @click.capture.stop.prevent="selectClient(client)"
            >
                <ClientCard
                    :id="client._id"
                    :logo="client.logoUrl"
                    :name="client.name"
                    :title="client.name"
                    :show-menu="false"
                />
            </a>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import clientsQuery from "@/apollo/queries/Clients.gql";
import ClientCard from "@/components/Client/ClientCard.vue";
import { defaultClientSortBy } from "@/enums/sort";
import type { Client } from "@/types/types";

export default defineComponent({
    components: {
        ClientCard
    },

    emits: ["client-selected"],

    data() {
        return {
            clients: [] as Client[]
        };
    },

    methods: {
        selectClient(client: Client) {
            this.$emit("client-selected", client);
        }
    },

    apollo: {
        clients: {
            query: clientsQuery,

            variables() {
                return {
                    orderBy: defaultClientSortBy,
                    wppProjectId: this.$store.state.auth?.wppOsContext?.project?.id
                };
            },

            result({ data: { clients } }) {
                this.clients = clients;
            }
        }
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;

.media-library__client-select {
    position: relative;

    &-title {
        margin-bottom: $spacing-base;
    }

    &-grid {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        &-card {
            width: 25%;
            padding: 0 $spacing-base;

            &:nth-child(1n) {
                padding-left: 0;
            }

            &:nth-child(4n) {
                padding-right: 0;
            }
        }
    }
}
</style>
